import React from 'react'
import { useTranslation } from 'react-i18next'
import Logo from '../../assets/Logo-white.svg'
import { useNavigate } from 'react-router-dom'
import { FiArrowRight } from 'react-icons/fi'
import { FaFacebookF, FaInstagram, FaYoutube } from 'react-icons/fa'

const Footer = () => {
  const { t } = useTranslation()
  const quickLinks = t("footer.quickLinks.links", { returnObjects: true })
  const companyLinks = t("footer.company.links", { returnObjects: true })


  const navPage = useNavigate()
  return (
    <footer className='relative mt-24 bg-[#1E1E1E] pt-6 text-[#9795B4]'>
      <div className='absolute left-0 top-[-50px] h-[100px] w-full skew-y-[-1.5deg] bg-[#1E1E1E]' />
      <div className='relative mx-auto my-12 flex w-[92%] max-w-6xl flex-wrap items-start justify-around gap-10'>
        <div className='w-full max-w-sm lg:max-w-[260px]'>
          <img className='my-2 cursor-pointer' src={Logo} alt="Be Alright Krabi Logo" role='button' onClick={() => navPage('/')} />
          <p className='text-lg' style={{ textAlign: 'justify' }}>{t("footer.desc")}</p>
          <div className='mt-4 flex w-full items-center justify-center gap-5'>
            <button className='rounded bg-white px-2 py-1 text-3xl text-slate-800 transition hover:scale-105' aria-label='Facebook' onClick={() => window.open('https://www.facebook.com/p/Krabi-Be-Alright-Tour-61563971601520/?fref=mentions&_rdr')}><FaFacebookF /></button>
            <button className='rounded bg-white px-2 py-1 text-3xl text-slate-800 transition hover:scale-105' aria-label='Instagram' onClick={() => window.open('https://www.instagram.com/krabibealrighttour/')}><FaInstagram /></button>
            <button className='rounded bg-white px-2 py-1 text-3xl text-slate-800 transition hover:scale-105' aria-label='YouTube' onClick={() => window.open('https://www.youtube.com/channel/UCLQdXEqwz5Y74XmL91z368Q')}><FaYoutube /></button>
          </div>
        </div>

        <div className='mt-5 flex w-full max-w-3xl flex-wrap items-start justify-center gap-10'>
          <div>
            <h3 className='text-2xl text-slate-100'>{t("footer.quickLinks.title")}</h3>
            <ul className='mt-2 list-none p-0'>
              <li className='my-2 cursor-pointer text-lg hover:underline' onClick={() => navPage('/')}>{quickLinks[0]}</li>
              <li className='my-2 cursor-pointer text-lg hover:underline' onClick={() => navPage('/bucket-list')}>{quickLinks[1]}</li>
              <li className='my-2 cursor-pointer text-lg hover:underline' onClick={() => navPage('/packages')}>{quickLinks[2]}</li>
            </ul>
          </div>
          <div>
            <h3 className='text-2xl text-slate-100'>{t("footer.company.title")}</h3>
            <ul className='mt-2 list-none p-0'>
              <li className='my-2 cursor-pointer text-lg hover:underline' onClick={() => navPage('/about')} role='button'>{companyLinks[0]}</li>
              <li className='my-2 cursor-pointer text-lg hover:underline' onClick={() => navPage('/about')} role='button'>{companyLinks[1]}</li>
            </ul>
          </div>
        </div>
      </div>

      <div className='text-center'>
        <button className='inline-flex items-center gap-2 rounded-full border border-slate-200 px-5 py-2 text-lg text-slate-100 transition hover:bg-slate-100 hover:text-slate-900' onClick={() => navPage('/packages')}>
          {t("footer.button")}
          <FiArrowRight />
        </button>
      </div>

      <hr className='my-3 border-slate-600' />
      <div className='py-3 text-center'>
        <p className='m-0'>Copyright © 2024 Catchify Technologies | All Rights Reserved | <a href='/terms-privacy' className='hover:underline'>{t("terms.title")}</a> | <a href='/terms-privacy' className='hover:underline'>{t("policy.title")}</a></p>
      </div>
    </footer>
  )
}

export default Footer
